import { render } from "./ViewClickCollectModal.vue?vue&type=template&id=53f602f1"
import script from "./ViewClickCollectModal.vue?vue&type=script&lang=js"
export * from "./ViewClickCollectModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__